// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/audit/GovernanceEventSummaryCards.jsx

import React from "react";

export default function GovernanceEventSummaryCards({ summary }) {
  const metrics = summary?.metrics || {};

  return (
    <div className="enterprise-admin-metric-grid enterprise-admin-compact-metrics enterprise-admin-governance-metrics">
      <div className="enterprise-admin-metric-card">
        <span>Total Events</span>
        <strong>{metrics.total_events || 0}</strong>
      </div>
      <div className="enterprise-admin-metric-card">
        <span>Last 7 Days</span>
        <strong>{metrics.last_7_days || 0}</strong>
      </div>
      <div className="enterprise-admin-metric-card">
        <span>Attention Events</span>
        <strong>{metrics.attention_events || 0}</strong>
      </div>
      <div className="enterprise-admin-metric-card">
        <span>Actors</span>
        <strong>{metrics.actor_count || 0}</strong>
      </div>
    </div>
  );
}
